import { SID } from "@securitize/domain";
import { UserInfo } from "../../../../types/UserInfo";

export const showsAsEnhanced = (user: UserInfo): boolean => {
  const currentInvestor = user.userInvestors.find(
    (ui) => ui.investorId === user.investorId,
  );
  return (
    user.isEnhancedVerificationRequested ||
    currentInvestor?.verificationLevel === SID.VerificationLevels.ENHANCED
  );
};

const countriesWithoutTaxIdRequirement = ["JP"];

export const countryDoesNotRequireTaxId = (countryCode: string): boolean => {
  return countriesWithoutTaxIdRequirement.includes(countryCode);
};
